import * as React from 'react';
import TableCell from '@mui/material/TableCell';

const IdentityDataCell = ({ column, value }) => (
  <TableCell key={column.id} align={column.align}>
    <b>{column.render(value)}</b>
  </TableCell>
);

export default IdentityDataCell;
